import { absolutePath } from "../absolutePath";

interface CheckoutSession {
  create: () => string;
}

export const checkoutSession: CheckoutSession = {
  create: () => absolutePath("account_payment_processors/checkout_sessions"),
};
